module.exports = __webpack_public_path__ + "img/professional-icon-03.be129c0a.png";